<div class="loader-wrapper" *ngIf="loading">
    <div class="loader">
        <!-- <img class="loader__animated" src="assets/img/footer-logo.png" alt=""> -->
        <img src="assets/img/footer-logo.png" alt="">
        <div class="material-spinner"></div>
    </div>
</div>